package net.gorillagroove.api

import kotlinx.serialization.Serializable

// I think is technically possible to make this generic, but it looks like absolute booty in 2025.
// I only really want to use this for Long values right now so that's all it works with.
@Serializable
data class LongListRequest(val items: List<Long>)
